let selectedShipFrequency = 1;
let selectedProduct = null;
let selectedSellingPlan = null;
let isGift = false;
let moneySign =
  document.querySelector('.num-received-container button').dataset
    .productPrice[0] ?? '$';

function convertCurrencyStringToNumber(currencyString) {
  // Remove any leading or trailing spaces:
  currencyString = currencyString.trim();

  // Use a regular expression to extract the numerical part:
  const numberMatch = currencyString.match(/^\D*(\d+(?:\.\d{2}|\,\d{2}))/);

  // If a numerical match is found, return it as a number:
  if (numberMatch) {
    return Number(numberMatch[1]);
  } else {
    // If no match is found, return NaN (Not a Number) to indicate an invalid input:
    return NaN;
  }
}

// const mostExpensiveBoxStringPrice = document.querySelector(
//   '.num-received-container button'
// ).dataset.productPrice;
// const mostExpensiveBoxQuantity = document.querySelector(
//   '.num-received-container button'
// ).dataset.numReceived;
// const MOST_EXPENSIVE_BOX =
//   convertCurrencyStringToNumber(mostExpensiveBoxStringPrice) /
//   Number(mostExpensiveBoxQuantity);

const MOST_EXPENSIVE_BOX = 44.99;

function prepaidHandleNumReceivedClick(numReceivedEl, isFirstLoad = false) {
  const numReceivedElement = isFirstLoad ? numReceivedEl : numReceivedEl.target;
  if (numReceivedElement.classList.contains('btn-selected')) return;
  const selected = document.querySelectorAll(
    '.num-received-container .btn-selected'
  );
  selected.forEach(function (element) {
    element.classList.remove('btn-selected');
  });

  selectedProduct = numReceivedElement.dataset.productId;
  selectedSellingPlan = numReceivedElement.dataset.sellingPlan;
  const productPrice = numReceivedElement.dataset.productPrice;
  const numReceived = numReceivedElement.dataset.numReceived;
  const shipFrequency = numReceivedElement.dataset.shipFrequencyProduct;
  document.querySelector('#product-price').innerHTML = productPrice;
  document.querySelector('.frequency-message').classList.remove('d-none');
  document.querySelector('.fire-level-container').classList.remove('d-none');
  document.querySelector('#message-shipments').innerHTML =
    Number(numReceived) === 1 ? ' 1 box' : ` ${numReceived} boxes`;
  const months = Number(numReceived) * Number(shipFrequency);
  document.querySelector('#message-months').innerHTML =
    months === 1 ? '1 month' : `${months} months`;

  const pricePerBox = parseFloat(
    parseFloat(productPrice.replace(moneySign, '')) / Number(numReceived)
  ).toFixed(2);

  document.querySelector('#product-price-per-box').innerHTML = `(${
    moneySign + pricePerBox
  } per box)`;
  numReceivedElement.classList.add('btn-selected');
  document
    .querySelector('#primary-add-to-cart-gift')
    .setAttribute('data-modal-opener', `gift_modal_${selectedProduct}`);
  document.querySelector('#primary-add-to-cart').classList.remove('disabled');
  document
    .querySelector('#primary-add-to-cart-gift')
    .classList.remove('disabled');

  const savingsPerBox = MOST_EXPENSIVE_BOX - pricePerBox;

  document.querySelector('#savings-per-box').innerHTML = `(${
    moneySign + Number(savingsPerBox).toFixed(2)
  } per box)`;
  const totalSavingsAmountEl = document.querySelector('#total-savings-amount');
  if (totalSavingsAmountEl) {
    totalSavingsAmountEl.innerHTML = `${
      moneySign + Number(savingsPerBox * numReceived).toFixed(2)
    }`;
  }

  const savingsImages = document.querySelectorAll('.fire-level');
  savingsImages.forEach(function (savingsImage, index) {
    if (savingsPerBox === 0) {
      if (index > 0) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 5) {
      if (index > 1) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 6) {
      if (index > 2) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 7) {
      if (index > 3) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox > 7) {
      savingsImage.classList.add('lit');
    }
  });
}

function prepaidHandleShipFrequencyClick(frequencyEl, isFirstLoad = false) {
  const frequencyElement = isFirstLoad ? frequencyEl : frequencyEl.target;

  if (frequencyElement.classList.contains('btn-selected')) return;

  document.querySelector('#product-price').innerHTML =
    'Select options to see price';
  document.querySelector('.fire-level-container').classList.add('d-none');
  document.querySelector('.frequency-message').classList.add('d-none');
  document.querySelector('#product-price-per-box').innerHTML = '';
  selectedProduct = null;
  document.querySelector('#primary-add-to-cart').classList.add('disabled');
  document.querySelector('#primary-add-to-cart-gift').classList.add('disabled');

  selectedShipFrequency = frequencyElement.dataset.shipFrequency;

  if (isFirstLoad) {
    let firstnumReceived;

    firstnumReceived = document.querySelector(
      `[data-ship-frequency-product="${selectedShipFrequency}"]`
    );
    prepaidHandleNumReceivedClick(firstnumReceived, true);
  } else {
    const selected = document.querySelectorAll('.btn-selected');
    const numReceivedSelectedEl = document.querySelector(
      '.num-received-container .btn-selected'
    );
    if (numReceivedSelectedEl) {
      const numReceivedSelected = numReceivedSelectedEl.dataset.numReceived;

      const newNumReceivedButton = document.querySelector(
        `[data-ship-frequency-product="${selectedShipFrequency}"][data-num-received="${numReceivedSelected}"]`
      );

      if (newNumReceivedButton) {
        prepaidHandleNumReceivedClick(newNumReceivedButton, true);
      }
    }

    selected.forEach(function (element) {
      element.classList.remove('btn-selected');
    });
  }

  frequencyElement.classList.add('btn-selected');
  prepaidHideProductsByFrequency(selectedShipFrequency);
}

function prepaidHideProductsByFrequency(frequency) {
  const products = document.querySelectorAll('[data-ship-frequency-product]');
  products.forEach(function (product) {
    if (product.dataset.shipFrequencyProduct != frequency) {
      product.classList.add('d-none');
    } else {
      product.classList.remove('d-none');
    }
  });
}

const frequencies = document.querySelectorAll('[data-ship-frequency]');
frequencies.forEach(function (frequencyEl) {
  const frequency = frequencyEl.dataset.shipFrequency;
  const frequencyPriceEls = document.querySelectorAll(
    `[data-ship-frequency-product="${frequency}"]`
  );

  Array.from(frequencyPriceEls).forEach(function (productButton, index) {
    const numReceived = productButton.dataset.numReceived;

    const frequencyPrice = (
      convertCurrencyStringToNumber(productButton.dataset.productPrice) /
      Number(numReceived)
    ).toFixed(2);

    // set price data on num received buttons
    const pricePerBoxEl =
      frequencyPriceEls[index].querySelector('.price-per-box');
    if (pricePerBoxEl && !pricePerBoxEl.dataset.noJsCalc) {
      console.log('calculating..........');
      pricePerBoxEl.innerHTML = moneySign + parseFloat(frequencyPrice);
    }

    if (MOST_EXPENSIVE_BOX - parseFloat(frequencyPrice) > 0) {
      frequencyPriceEls[index].querySelector(
        '.savings-per-box'
      ).innerHTML = `save ${
        moneySign + (MOST_EXPENSIVE_BOX - parseFloat(frequencyPrice)).toFixed(2)
      } / box`;
    }

    return parseFloat(frequencyPrice);
  });

  frequencyEl.addEventListener('click', prepaidHandleShipFrequencyClick);
});

const numReceivedElements = document.querySelectorAll('[data-num-received]');
numReceivedElements.forEach(function (numReceivedEl) {
  numReceivedEl.addEventListener('click', prepaidHandleNumReceivedClick);
});

document
  .querySelector('#primary-add-to-cart')
  .addEventListener('click', async function (e) {
    await prepaidAddToCart(selectedProduct, selectedSellingPlan);
  });

document
  .querySelector('#primary-add-to-cart-gift')
  .addEventListener('click', async function (e) {
    document.querySelector(`#gift_modal_${selectedProduct}`).show(e.target);
  });

const optionalProductsContainers = document.querySelectorAll(
  '.optional-product-card'
);

const randomOptionalProduct =
  optionalProductsContainers[
    Math.floor(Math.random() * optionalProductsContainers.length)
  ];
randomOptionalProduct.classList.remove('d-none');

const optionalProducts = document.querySelectorAll(
  '.optional-product-add-to-cart'
);

optionalProducts.forEach(function (optionalProduct) {
  optionalProduct.addEventListener('click', async function () {
    ghjg;
    await prepaidAddToCart(optionalProduct.dataset.productId);
  });
});

async function prepaidAddToCart(productId, sellingPlan = null) {
  const body = {
    id: productId,
    quantity: 1,
    properties: {
      _is_subscription: true,
    },
  };

  if (!!sellingPlan) {
    body.selling_plan = sellingPlan;
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  await response.json();
}

const monthlyShipEl = document.querySelector('[data-ship-frequency="1"]');
prepaidHandleShipFrequencyClick(monthlyShipEl, true);

// if window size is less than 768px, scroll to the slider
if (window.innerWidth < 768) {
  const sliderContainer = document.querySelector(
    '.d-md-none.slider-element-container'
  );

  window.scrollTo({
    top: sliderContainer.offsetTop - 65,
    behavior: 'smooth',
  });
}

const populateProgressBar = data => {
  const progress = document.querySelector('.progress-bar .progress');
  const progressWidth = Math.min((data.total_price / 25000) * 100, 100);
  progress.style.width = `${progressWidth}%`;

  if (data.total_price >= 25000) {
    document
      .querySelector('.progress-bar-section-container')
      .classList.add('complete');
  } else {
    document
      .querySelector('.progress-bar-section-container')
      .classList.remove('complete');
    const amountRemainingEl = document.querySelector('#amount-remaining');
    const amountRemaining = (25000 - data.total_price) / 100;
    amountRemainingEl.innerHTML = amountRemaining.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
};

// when the page loads query the cart to populate the progress bar
// fetch('/cart.js')
//   .then(res => res.json())
//   .then(populateProgressBar);

// (function (ns, fetch) {
//   if (typeof fetch !== 'function') return;

//   ns.fetch = function () {
//     const response = fetch.apply(this, arguments);

//     response.then(res => {
//       if (
//         [
//           `${window.location.origin}/cart/add.js`,
//           `${window.location.origin}/cart/update.js`,
//           `${window.location.origin}/cart/change.js`,
//           `${window.location.origin}/cart/clear.js`,
//         ].includes(res.url)
//       ) {
//         res
//           .clone()
//           .json()
//           .then(data => {
//             if (Object.hasOwn(data, 'total_price')) {
//               populateProgressBar(data);
//             } else {
//               fetch('/cart.js')
//                 .then(res => res.json())
//                 .then(populateProgressBar);
//             }
//           });
//       }
//     });

//     return response;
//   };
// })(window, window.fetch);
